<template>
  <div class="changePwd">

    <div class="bm_panel">

      <div class="bmtit">
        <div class="bmt1">修改密码</div>
        <div class="bmt2">{{this.$route.params.username}}</div>
      </div>

      <el-form class="ruleForm" :model="ruleForm" :rules="rules" ref="ruleForm1" >

        <el-form-item  class="it2" prop="originalPass">
          <el-input type="password" v-model="ruleForm.originalPass" autocomplete="off" prefix-icon="el-icon-lock" placeholder="输入原始密码"></el-input>
        </el-form-item>


        <el-form-item  class="it2" prop="newPass">
          <el-input type="password" v-model="ruleForm.newPass" autocomplete="off" prefix-icon="el-icon-lock" placeholder="输入新密码"></el-input>
        </el-form-item>

        <el-form-item  class="it2" prop="again_newPass">
          <el-input type="password" v-model="ruleForm.again_newPass" autocomplete="off" prefix-icon="el-icon-lock" placeholder="确认新密码"></el-input>
        </el-form-item>

        
        <el-form-item class="it5">
          <el-button class="submit_btn" type="primary" @click="submitForm('ruleForm1')">确定</el-button>
        </el-form-item>
      </el-form>

    </div>

  </div>
</template>

<script>

export default {
  name: 'changePwd',
  data:function () {
    var check_originalPass = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('原始密码不能为空'));
      }
      callback();
    };
    var check_newPass = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('新密码不能为空'));
      }
      callback();
    };
    var check_again_newPass = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('确认密码不能为空'));
      }

      if(value != this.ruleForm.newPass){
        return callback(new Error('两次输入密码不一致'));
      }
      callback();
    };
    return {
      ruleForm: {
        originalPass:'',
        newPass:'',
        again_newPass:''
      },

      rules: {
        originalPass: [
         { validator: check_originalPass },
        ],
        newPass: [
          { validator: check_newPass },
        ],
        again_newPass: [
          { validator: check_again_newPass },
        ],
      },
      
    }
  },
  created(){
    console.log("changePwd created", this.$route)
    
  },
  methods:{
    async fetch(){
      let sendObj = {
            original_password:this.ruleForm.originalPass,
            password:this.ruleForm.newPass,
          };

      let res = await this.$fly.get('/user/resetPassword',sendObj);
      console.log("res:", res);

      if (res === 200){
        this.$message({
          message: '修改密码成功！',
          type: 'success'
        });

        this.$refs['ruleForm1'].resetFields();
      }
      
    },
    submitForm(formName) {
      let self = this;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          self.fetch();
        } else {
          console.log('error submit!!');
          // return false;
        }
      });

    },
  }
}
</script>

<style lang='scss'>

.changePwd{

  .bm_panel{
    width: 246px;
    margin: 60px auto;
    z-index: 9;
    background-color:#fff;
    border-radius: 10px;
    box-shadow: 0 2px 4px 0 rgba(0,0,0,0.50);
    padding: 20px;

    .bmtit{
      text-align: center;
      font-size: 20px;
      color: #00B3A4;
      margin-bottom: 20px;

      .bmt2{
        font-size: 10px;
        color: #999999;
        margin: 10px 0;
      }
    }

    .ruleForm{

      .it5{
        margin-bottom: 0;
      }

      .submit_btn{
        width: 100%;
      }

    }

  }
  
}

</style>